import React from 'react';
import { StaticQuery, graphql } from "gatsby"

const WorkflowSection = () => (
   <StaticQuery
         query={graphql`
            query {
                allWpPage(filter: {slug: {eq: "work-flow"}}) {
                    edges {
                      node {
                        slug
                        TeamlanceWorkflow {
                          header {
                            title
                            description
                          }
                          workSteps {
                            steps {
                              description
                              readMoreLink
                              readMoreText
                              title
                              subTitle
                            }
                          }
                          workFeatures {
                            features {
                              title
                              iconSvg
                              description
                            }
                          }
                        }
                      }
                    }
                  }
            }
         `}
         render={data => {
            return(
              data && data.allWpPage &&
              data.allWpPage.edges &&
              data.allWpPage.edges[0] &&
              data.allWpPage.edges[0].node &&
              data.allWpPage.edges[0].node.TeamlanceWorkflow &&
              data.allWpPage.edges[0].node.TeamlanceWorkflow.workSteps &&
              data.allWpPage.edges[0].node.TeamlanceWorkflow.workSteps.steps &&
              data.allWpPage.edges[0].node.TeamlanceWorkflow.workSteps.steps.length>0 &&
              <section className="workflow-sec">
               <div className="workflow-triangle">
                  <svg width="366" height="185" viewBox="0 0 366 185" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M51.8221 167.583L-35.3348 87.7328L-40 34.2603L358.287 64.1671L83.1531 173.347C72.4676 177.588 60.2986 175.349 51.8221 167.583Z" fill="#D8F4FF"></path>
                  </svg>
               </div>
               <div className="container py-md-5 py-sm-4">
                  <div className="col-12 workflow-main">
                     <div className="workflow-container">
                        <div className="workflow-grid empty-h">
                           <div className="workflow-grid-empty"></div>
                        </div>
                     </div>
                     <ul className="workflow-container">
                        {data.allWpPage.edges[0].node.TeamlanceWorkflow.workSteps.steps.map((steps,key)=>{
                            return(
                              <li key={key} className={key === data.allWpPage.edges[0].node.TeamlanceWorkflow.workSteps.steps.length-1?"workflow-grid wk-two":key===0?"workflow-grid wk-one":"workflow-grid"}>
                                    <div className="list-count ">
                                       <h6>{key+1}</h6>
                                    </div>
                                    <div className="workflow-div">
                                       <h4>{steps.title}<br />
                                          <span>{steps.subTitle}</span>
                                       </h4>
                                       <p>{steps.description}</p>
                                       {steps.readMoreText?(<a href={steps.readMoreLink}>{steps.readMoreText}</a>):null}
                                    </div>
                              </li>
                            )
                        })}
                     </ul>
                     <div className="workflow-container">
                        <div className="workflow-grid empty-h">
                           <div className="workflow-grid-empty1"></div>
                        </div>
                     </div>
                  </div>
                 </div>
              </section>
             )
         }}
    />
  
)

export default WorkflowSection;